import { render, staticRenderFns } from "./CalendarTypeSelector.vue?vue&type=template&id=0a84ea9b"
import script from "./CalendarTypeSelector.vue?vue&type=script&lang=js"
export * from "./CalendarTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports